import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 20px;
  text-align: center;
`
